import Select from './select';
import Css from './css';
import Ajax from './ajax';
import Loading from './loading';
import {validateAddingProductForms} from './validateAddingProductForms';
import productQtyInputDisplayEstimate from './productQtyInputDisplayEstimate';
import {init as productListPreviewsInit} from './productListPreviews';

export default {
    showProductCategoryButtons: null,
    showProductCategoryButtonsList: null,
    categoryProductListsContainer: null,
    loadingObj: null,
    url: window.location.origin + '/api/v1/product-category/products/',
    init: function(){
        this.showProductCategoryButtonsList = Select.one('[data-subcategory-tabs-list]');
        if( this.showProductCategoryButtonsList !== null ){
            this.onPopStateEvent();
            this.showProductCategoryButtons = Select.all('[data-button="view-category-products"]', this.showProductCategoryButtonsList);
            if(this.showProductCategoryButtons !== null){
                this.categoryProductListsContainer = Select.one('[data-category-product-lists]');
                this.loadingObj = new Loading();
                if(this.showProductCategoryButtons.length){
                    var self = this;
                    for ( var i= 0, len=this.showProductCategoryButtons.length; i < len; i++){
                        this.showProductCategoryButtons[i].addEventListener('click', function(e){
                            self.onShowProductCategoryButtonsClick(e, this);
                        }, false);
                    }
                }
            }
        }
    },
    onShowProductCategoryButtonsClick: function(e, el){
        var categoryId = e.target.getAttribute('data-product-category-id'),
            heading = e.target.getAttribute('title'),
            href = e.target.getAttribute('href');
        if( categoryId ){
            e.preventDefault();
            var categoryProductsListElement = this.getCachedCategoryProductsListElement( categoryId );
            if( categoryProductsListElement !== null ){
                this.hideAllCategoryProductLists();
                this.resetAllSelectedButtons();
                this.showCategoryProductList(categoryProductsListElement, categoryId);
                this.selectButton(el);
                this.setPushState(href, categoryId);
            }
            else{
                this.fetchProductListForCategory( categoryId, el, href, heading );
            }
        }
    },
    fetchProductListForCategory: function( categoryId, elForLoadIndicator, stateHref, heading ){
        this.loadingObj.insertLoadingElement(elForLoadIndicator);
        var self = this;
        Ajax('POST', this.url + encodeURIComponent(categoryId) + ''  , { format: 'html', display_recnav: 1 }, function (response) {
            var responseJson = JSON.parse(response);
            if(responseJson.data.hasOwnProperty('html')){
                var categoryProductListEl = document.createElement('div'),
                    headingHtml = '';
                if(heading)
                    headingHtml = '<h3 class="product-category__category__subcategory__product-list__heading" data-category-product-list-heading >' + heading + '</h3>';
                Css.addClass( categoryProductListEl , 'product-category__category__subcategory__product-list');
                categoryProductListEl.setAttribute( 'data-category-product-list', categoryId );
                categoryProductListEl.setAttribute( 'aria-hidden', 'false');
                categoryProductListEl.innerHTML = headingHtml + responseJson.data.html;
                validateAddingProductForms( categoryProductListEl );
                productQtyInputDisplayEstimate.init(categoryProductListEl);
                productListPreviewsInit(categoryProductListEl);
                self.hideAllCategoryProductLists();
                self.resetAllSelectedButtons();
                self.categoryProductListsContainer.appendChild(categoryProductListEl);
                self.selectButton(elForLoadIndicator);
                self.setPushState(stateHref, categoryId);
            }
            self.loadingObj.removeLoadingElement();
        },function(status, response){
            self.loadingObj.removeLoadingElement();
        });
    },
    getCachedCategoryProductsListElement: function(categoryId){
        if(categoryId)
            return Select.one('[data-category-product-list="' + categoryId + '"]');
    },
    showCategoryProductList: function(el, categoryId){
        var categoryProductList = el || Select.one('[data-category-product-list="' + categoryId + '"]');
        if(categoryProductList !== null){
            Css.removeClass(categoryProductList, 'hide');
            categoryProductList.setAttribute('aria-hidden', 'false');
        }
    },
    hideAllCategoryProductLists: function(){
        var categoryProductLists = Select.all('[data-category-product-list][aria-hidden="false"]', this.categoryProductListsContainer);
        if(categoryProductLists !== null && categoryProductLists.length){
            for ( var i= 0, len=categoryProductLists.length; i < len; i++){
                Css.addClass(categoryProductLists[i], 'hide');
                categoryProductLists[i].setAttribute('aria-hidden', 'true');
            }
        }
    },
    selectButton: function(el){
        Css.addClass(el.parentNode, 'selected');
    },
    resetAllSelectedButtons: function(){
        var selectedButtons = Select.all('.selected', this.showProductCategoryButtonsList);
        if(selectedButtons !== null && selectedButtons.length){
            for ( var i= 0, len=selectedButtons.length; i < len; i++){
                Css.removeClass(selectedButtons[i], 'selected');
            }
        }
    },
    setPushState: function(href, categoryId){
        if (history.pushState) {
            var stateObj = { productCategory: categoryId };
            history.pushState(stateObj, categoryId , href);
        }
    },
    onPopStateEvent: function(){
        var self = this;
        window.onpopstate = function(e) {
            if(e.state !== null && e.state.hasOwnProperty('productCategory')){
                var button = Select.one('[data-button="view-category-products"][data-product-category-id="' + e.state.productCategory + '"]', self.showProductCategoryButtonsList);
                if(button !== null){
                    var categoryId = button.getAttribute('data-product-category-id'),
                        href = button.getAttribute('href');
                    if( categoryId ){
                        var categoryProductsListElement = self.getCachedCategoryProductsListElement( categoryId );
                        if( categoryProductsListElement !== null ){
                            self.hideAllCategoryProductLists();
                            self.resetAllSelectedButtons();
                            self.showCategoryProductList(categoryProductsListElement, categoryId);
                            self.selectButton(button);
                        }
                        else{
                            self.fetchProductListForCategory( button.getAttribute('data-ajax'), categoryId, button, href );
                        }
                    }
                }
            }
        };
    }
};
